// Prefer runtime config injected by /config.js, then CRA env var, then default.
const runtime = (typeof window !== 'undefined' && window._env_) ? window._env_ : {};
const API_URL = runtime.API_URL
    || (typeof process !== 'undefined' && process.env && process.env.REACT_APP_API_URL)
    || 'http://localhost:8080'; // local default

export default API_URL;

// If you use Vite instead of CRA, swap the middle part to:
//   || (typeof import !== 'undefined' && import.meta && import.meta.env && import.meta.env.VITE_API_URL)
